
import { useUtils as useAclUtils } from '@composables/acl'

const { canViewVerticalNavMenuHeader } = useAclUtils()

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render(h) {
    const span = h('span', {}, this.item.header)
    const icon = h('font-awesome-icon', { props: { icon: 'fas fa-ellipsis'}, class: 'ms-1  my-0 py-0' })
    if (canViewVerticalNavMenuHeader(this.item)) {
      return h('li', { class: 'navigation-header text-truncate' }, [span,icon])
    }
    return h()
  }
}
